import { render, staticRenderFns } from "./SBTextInput.vue?vue&type=template&id=3d5e72bd&scoped=true&"
import script from "./SBTextInput.vue?vue&type=script&lang=js&"
export * from "./SBTextInput.vue?vue&type=script&lang=js&"
import style0 from "./SBTextInput.vue?vue&type=style&index=0&id=3d5e72bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5e72bd",
  null
  
)

export default component.exports